import emptyImg from "../../public/img/nft-auth/empty.png";
import Image from "next/legacy/image";
import { useTranslation } from "next-i18next";

export const Empty = () => {
  const { t } = useTranslation("nftauth");

  return (
    <div className="flex flex-col items-center justify-center mt-[120px]">
      <Image src={emptyImg} width={460} height={200} alt="" />
      <div className="text-[#E3E5E7] text-[18px] mt-[24px]">{t("t29")}</div>
    </div>
  );
};
